import { createStyles, Fade, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsErrorLabel = withStyles(({ palette, spacing }) =>
  createStyles({
    root: {
      fontSize: 14,
      color: palette.error.main,
      margin: spacing(1),
    },
  })
)((props: TypographyAllProps) => (
  <Fade in timeout={300}>
    <Typography variant="body1" component="p" {...props} />
  </Fade>
));

export default FsErrorLabel;
